<ng-container *ngIf="data as d; else noData">
    <ng-container [ngSwitch]="d.type">
        <app-iframe-video-player
            *ngSwitchCase="'iframe'"
            [url]="d.uri"
        ></app-iframe-video-player>

        <p *ngSwitchDefault>Invalid video type</p>
    </ng-container>
</ng-container>

<mat-dialog-actions>
    <button mat-flat-button color="primary" mat-dialog-close>Close</button>
</mat-dialog-actions>

<ng-template #noData>
    <p>No video data provided</p>
</ng-template>
